import React from 'react';

import type { ExtensionManifest } from '@atlaskit/editor-common/extensions';

import Icon from '../../../../prebuilt/config-items-empty/generate-content/Icon';
import { AIPanelRenderer } from '../../ai-panel-renderer/AIPanelRenderer';
import type { AIManifest, AIPanelParameters } from '../../types';
import { getFeedbackToolbarItem, getQualityToolbarItem } from '../../utils';

import { messages } from './messages';

const buildSummarisePagePanelManifest = ({
	api,
	intl,
	providerFactory,
}: AIManifest): ExtensionManifest<AIPanelParameters> => {
	return {
		title: intl.formatMessage(messages.summarizePageTitle),
		type: 'com.atlassian.ai-blocks',
		key: 'ai-summary-block',
		description: intl.formatMessage(messages.summarisePageDescription),
		icons: {
			'48': async () => () => <Icon alt={intl.formatMessage(messages.summarizePageTitle)} />,
		},
		modules: {
			nodes: {
				aiSummaryBodiedExtension: {
					type: 'bodiedExtension',
					render:
						async () =>
						({ node }) => {
							return <AIPanelRenderer node={node} providerFactory={providerFactory} />;
						},
				},
			},
			contextualToolbars: [
				{
					context: {
						type: 'extension',
						nodeType: 'bodiedExtension',
						extensionKey: 'ai-summary-block:aiSummaryBodiedExtension',
						extensionType: 'com.atlassian.ai-blocks',
					},
					toolbarItems: [getQualityToolbarItem(intl), getFeedbackToolbarItem(intl, api, messages)],
				},
			],
		},
	};
};

export default buildSummarisePagePanelManifest;
